import { render } from "./presupuesto_generados_detalle.vue?vue&type=template&id=9890d416"
import script from "./presupuesto_generados_detalle.vue?vue&type=script&lang=js"
export * from "./presupuesto_generados_detalle.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__